import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullCheck'
})
export class NullCheckPipe implements PipeTransform {

  transform(value: any, showZero?: boolean): any {
    if (value === null ||
      value === undefined ||
      value === '') {
      return showZero ? 0 : '--';
    }

    return value;
  }

}
